import { render, staticRenderFns } from "./BitacoraEmbarcaciones.vue?vue&type=template&id=43a20b86"
import script from "./BitacoraEmbarcaciones.vue?vue&type=script&lang=js"
export * from "./BitacoraEmbarcaciones.vue?vue&type=script&lang=js"
import style0 from "./BitacoraEmbarcaciones.vue?vue&type=style&index=0&id=43a20b86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports